import Constants from '../constants';
import { IReportingUser } from '../models';

export function createStorageKey(surveyId: number) {
	return Constants.LOCAL_STORAGE_KEY_REPORTING_USERS + '_' + surveyId;
}

export function saveToSessionStorage(surveyId: number, users: IReportingUser[]) {
	const keyValue = createStorageKey(surveyId);
	sessionStorage.setItem(keyValue, JSON.stringify(usersToEmails(users)));
}

export function appendSessionEmailInfo(surveyId: number, users: IReportingUser[]) {
	const keyValue = createStorageKey(surveyId);
	const storedHasSentEmailVals = sessionStorage.getItem(keyValue);
	if (storedHasSentEmailVals === null) {
		return users;
	} else {
		const parsedVals = JSON.parse(storedHasSentEmailVals);
		return setHasSentEmail(users, parsedVals);
	}
}

export function setHasSentEmail(users: IReportingUser[], vals: string[]) {
	return users.map((user) => (vals.includes(user.emailAddress) ? { ...user, hasSentEmail: true } : user));
}

export function usersToEmails(users: IReportingUser[]) {
	return users.filter((user) => user.hasSentEmail).map((user) => user.emailAddress);
}

export const ReportingSessionStorageHandler = {
	createStorageKey,
	saveToSessionStorage,
	appendSessionEmailInfo,
	setHasSentEmail,
	usersToHasSentEmails: usersToEmails,
};
